export const getColour = (colourString) => {
  if (colourString === "black") return "#000000";
  if (colourString === "white") return "#FFFFFF";
  return colourString;
};

export default () => {};
